import React from 'react';

const field = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group ${touched && error ? 'has-danger':''}`}>
        {typeof title === 'undefined' ? null:<label className="form-control-label">{title}</label>}
        <input {...input}  placeholder={placeholder} name={name} className="form-control" type="text" disabled={(typeof disabled === 'undefined' ? false:disabled)} autoComplete="off" />
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

export default field;


// WEBPACK FOOTER //
// ./components/ReduxForm/text.js